export function isValidDSN(dsn = "") {
  if (!dsn) {
    return false;
  }
  return dsn.startsWith("http") || dsn.startsWith("//");
}

// 尝试手动补全协议
export function getDSN(rawDSN = "") {
  if (!rawDSN) {
    return "";
  } else {
    if (rawDSN.startsWith("http")) {
      return rawDSN;
    } else if (rawDSN.startsWith("//")) {
      return `${window.location.protocol}${rawDSN}`;
    } else {
      return "";
    }
  }
}
